import { urlTransform } from "../../presentation/hooks/ImageHook";
export function mergeRentersWithImages(renters, carRenters) {
    const carRentersMap = new Map(carRenters.map((c) => [c.code, c]));
    return renters.map(renter => {
        const match = carRentersMap.get(renter.value);
        if (match && typeof match.image === "string" && match.image.length > 0) {
            return {
                ...renter,
                image: {
                    ...renter.image,
                    src: urlTransform(match.image, 200)
                }
            };
        }
        return renter;
    });
}
